// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3CFBX","footer":"styles_footer__3Kuz8","passCodeTooltip":"styles_passCodeTooltip__2Wk5j"};